import type { RouteRecordRaw } from "vue-router";

export const authRoutes: RouteRecordRaw[] = [
  {
    path: "/sign-in",
    name: "sign-in",
    component: () => import(/* webpackChunkName: "dashboard-sign-in" */ "../../components/auth/SignInView.vue"),
    meta: { titleKey: "pageTitle.signIn", layout: "auth", viewGroup: "sign-in" }
  },
  {
    path: "/verify-fingerprint",
    name: "verify-fingerprint",
    component: () =>
      import(/* webpackChunkName: "dashboard-verify-fingerprint" */ "../../components/auth/VerifyFingerPrintView.vue"),
    meta: {
      titleKey: "pageTitle.verifyFingerprint",
      layout: "auth",
      viewGroup: "verify-fingerprint"
    }
  }
];
